export const extractAuth0MetaData = (
  user: any
): {
  userName: string | null;
  userEmail: string | null;
  isLegacyCHPUser: boolean;
} => {
  if (!user) {
    return { userName: null, userEmail: null, isLegacyCHPUser: false };
  }

  console.log(user);

  const userName =
    user?.["https://amosinstitute.com/app_metadata"].firstName +
    " " +
    user?.["https://amosinstitute.com/app_metadata"].lastName;
  const userEmail = user?.email;

  // Eg. '2023-05-01'
  const legacyCHPStartDate =
    user?.["https://amosinstitute.com/app_metadata"].CHPStartDate;

  const isLegacyCHPUser =
    legacyCHPStartDate && new Date(legacyCHPStartDate) < new Date("2025-06-01");

  return { userName, userEmail, isLegacyCHPUser };
};
